import vue from 'vue'
import { structure, nonClearableFields } from './structure'
import { cloneDeep } from 'HELPERS'

export default {
  state: {
    ...cloneDeep(structure)
  },
  getters: {
    getInfoCity: state => state.city
  },
  mutations: {
    INFO_STORE_RESET(state) {
      for (const field in structure) {
        if (nonClearableFields.includes(field)) continue
        state[field] = cloneDeep(structure[field])
      }
    },
    INFO_SET(state, [field, value]) {
      if (field.includes('.')) {
        const [parent, child] = field.split('.')
        vue.set(state[parent], `${child}`, value)
      } else {
        state[field] = value
      }
    },
    INFO_SET_NAV_HISTORY(state, value) {
      if (value === -1) {
        state.objectNavHistory.pop()

        return
      }

      state.objectNavHistory.push(value)

      if (value === null) {
        state.objectNavHistory.length = 0
      }
    },
    INFO_PUSH(state, [field, value]) {
      state[field].push(value)
    },
    INFO_SPLICE(state, [field, value]) {
      const index = state[field].findIndex(i => i.id === value.id)

      if (index >= 0) state[field].splice(index, 1)
    }
  }
}
